export enum QuarantineReasons {
  NoWebSuite = 1,
  NoXo = 2,
  NotIC = 3,
  AlreadyExists = 4,
  NoUsTag = 5,
  UnmatchedPnSn = 6,
  LastOhIsMissing = 7,
  FHCInfoMissing = 8,
  DamageMissingPart = 9,
  Other = 10,
}
